const Selectors = {
  widget: {
    target: ".wrapper",
    waitFor: ".qw-price__main-price, .qw-input__firstName",
    mobileWidgetTarget: ".wrapper",
    mobileHeightTarget: ".qw-calendar-guest-inline__action",
    widget: "#guestbook-widget",
    stickyWidget: "#guestbook-sticky-widget",
  },
  ratesPage: {
    waitFor: ".qw-price__main-price",
    contentChangeTarget: ".qw-price__main-price",
    rates: ".qw-price__main-price",
    ratesMessage: ".gb-rates-message", // attr data-room-code
    currency: ".qw-select__qw-currency select",
    currencyExtrasPage: ".qw-room-rate__price-active",
    total: ".qw-basket__price-total",
  },
  paymentPage: {
    waitFor: ".qw-input__firstName",
    contentChangeTarget: ".basket-header__wrapper",
    firstname: ".booking-confirm__customer",
    lastname: ".basket-panel__customer",
    firstNameInput: ".qw-input__firstName input",
    lastNameInput: ".qw-input__lastName input",
    email: ".qw-input__emailAddress input",
    checkin: ".flatpickr-day.selected.startRange",
    checkout: ".flatpickr-day.selected.endRange",
    total: ".pricefrom",
    roomNames: ".qw-room-list-card__title-content",
    rateNames: ".qw-basket-summary__room-rate-name",
    enrollmentMessageContainer: "#guestbook-enrollment",
    rewardsMessageTarget: "",
    saveInfoTarget: ".qw-book__pay",
    extras:
      ".items__content .qw-extra-card__price .qw-extra-card__price-content",
    checkbox: "input[name=guestbook-enroll]",
    paymentPageReserveButton: ".qw-book__pay .qw-button",
  },
  confirmationPage: {
    waitFor: ".booking-info__value",
    messageTarget: ".basket-panel.confirmation-page__basket-panel",
    confirmationMessageContainer: "#guestbook-confirm",
    confirmationNumber: ".booking-info__value",
    total: ".basket__group .basket__line__price",
    cancellationNumber: ".ctx-booking-reference",
    cancellationTarget:
      ".ctx-modify-booking-content .avp-banner-message.banner-message--information",
  },
  cancellationPage: {
    checkedRooms: 'input[name="rooms_to_cancel[]"]',
  },
};

export default Selectors;
